import React, { useEffect } from "react";
import Banner from '../../assets/Images/Header_banner.webp';
import whatsHappingBanner from '../../assets/Images/Whats_happing_image.webp';



/* AOS LIBRARY */
import AOS from 'aos';
import 'aos/dist/aos.css';


/* SCSS IMPORTATION */
import '../Banner/Banner.scss'


function HeaderBanner() {


    /* AOS  */
    useEffect(() => {
        AOS.init();
    }, [])



    return (

        <>
            <div className="Header_Banner">
                <img className="image" data-aos="zoom-out" data-aos-delay="5s" data-aos-duration="2800" src={Banner} />
            </div>

            <div className="WHATS_HAPPENING ">
                <div className="text">
                    <h2>HERE’S WHATS HAPPENING</h2>
                </div>

                <div className="image">
                    <img src={whatsHappingBanner} />
                </div>
            </div>
        </>
    )
}

export default HeaderBanner;